const companiesWithInspeccion = ["Sancor", "RUS"];
export default companiesWithInspeccion;